module.exports = __webpack_public_path__ + "img/ssyx_08.5eb46866.jpg";